export const defaultBrandData: any = {
  id: '',
  name: '',
  region: '',
  isActive: false
}
